import { ChangeEvent, Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { Icon, Input, InputOnChangeData, Label } from "semantic-ui-react";
import { TranslateProps } from "../../../i18n/TranslateProps";
import { ICertificate } from "../../../models/certificate";

type Props = {
    certificate: ICertificate;
    setCertificate: Dispatch<SetStateAction<ICertificate>>;
    existingStretches: string;
};

export const ManualStretchesDetailsForm = ({
    certificate,
    setCertificate,
    existingStretches,
}: Props) => {
    const intl = useIntl();
    const [manualStretches, setManualStretches] = useState<string>(existingStretches);
    const stretchRegex: RegExp = /^[A-Z][A-Z-]-\d\d\d\d-\d\d\d\d$/;
    const [invalidStretch, setInvalidStretch] = useState(false);

    const validateStretch = (stretch: string) => {
        if (stretchRegex.exec(stretch)) {
            setInvalidStretch(false);
        }
    };

    const handleAddManualRanges = (e: any) => {
        if (e.key === "Enter" || e.charCode === 13) {
            setInvalidStretch(false);
            if (stretchRegex.exec(e.target.value)) {
                setManualStretches(`${manualStretches}${e.target.value};`);
                setCertificate({
                    ...certificate,
                    stretchesManualRiverKilometers: `${manualStretches}${e.target.value};`,
                });
            } else {
                setInvalidStretch(true);
            }
        }
    };

    const handleRemoveStretch = (s: string) => {
        setManualStretches(manualStretches.replace(`${s};`, ""));
        setCertificate({
            ...certificate,
            stretchesManualRiverKilometers: manualStretches.replace(`${s};`, ""),
        });
    };

    return (
        <>
            <section className="input-container">
                <label>{intl.formatMessage({ id: "manualAddSections" })}</label>
                <Input
                    className={invalidStretch ? "invalidStretch" : ""}
                    onChange={(_e: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
                        validateStretch(data.value);
                    }}
                    onKeyPress={(e: any) => {
                        handleAddManualRanges(e);
                    }}
                />
                {manualStretches
                    .split(";")
                    // remove last element (empty)
                    .slice(0, -1)
                    .map((s, i) => (
                        <Label as="a" key={i}>
                            {s}
                            <Icon name="delete" onClick={() => handleRemoveStretch(s)} />
                        </Label>
                    ))}
                {invalidStretch && (
                    <label className="invalidLabel">
                        {intl.formatMessage({ id: "wrongStretchCodeFormat" })}
                    </label>
                )}
            </section>
        </>
    );
};
